// 📁 src/components/Compta/ComptaItems.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";

// 🔽 Import des hooks personnalisés
import { useGroupe } from "../../context/GroupeContext.js";
import { useContacts } from "../../hooks/useContacts.js";
import { useContactsPeriodeDominante } from "../../hooks/useContactsPeriodeDominante.js";
import { useAdminRole } from "../../hooks/useAdminRole.js";

// 🔽 Composant d’affichage principal
import TableauCompta from "./TableauCompta.js";

// 🔽 Utilitaire pour construire les lignes (non utilisé ici mais importé)
import { logDev } from "../../utils/logger.js";

// 🔽 Composant principal
const ComptaItems = ({ headerHeight = 0 }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { groupeId } = useGroupe();
  const role = useAdminRole(groupeId);
  const isAdmin = role === "admin";

  // 📥 Récupération des contacts et de la période dominante
  const { contacts, periodeDominante } = useContacts(groupeId);

  // 🧠 Filtrage des contacts selon la période dominante
  const { contactsDominante } = useContactsPeriodeDominante(contacts, {
    winningKey: periodeDominante,
    onlyValidEmails: true,
    fallbackAll: true // ✅ pour afficher tous les contacts si aucun match
  });

  // 📊 État local pour stocker les lignes comptables fusionnées
  const [rows, setRows] = useState([]);

  // 🔄 Fonction pour charger les données de compta et les fusionner avec les contacts
  const fetchCompta = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/compta/${groupeId}`);
      logDev("[ComptaItems] réponse brute compta", res.data);
      const comptaData = res.data;

    // 🔁 Fusion des données : contact + compta
    const lignes = contactsDominante.map(contact => {
      const compta = comptaData.find(c => c.contactId === contact._id);
      return {
        _id: contact._id,
        nom: contact.nom || "",
        virement1: compta?.virement1 || 0,
        date1: compta?.date1 || null,
        virement2: compta?.virement2 || 0,
        date2: compta?.date2 || null
      };
    });

    setRows(lignes);
    logDev("[ComptaItems] lignes fusionnées", lignes);
  } catch (err) {
    logDev("❌ Erreur chargement compta", { message: err.message, stack: err.stack });
  }
};

// 📦 Chargement initial des données comptables dès que les contacts sont prêts
useEffect(() => {
  if (contactsDominante.length > 0 && groupeId) {
    fetchCompta();
  }
}, [contactsDominante, groupeId]);

 // 🖥️ Rendu du tableau comptable
  return (
    <TableauCompta
      contacts={contactsDominante}
      periodeDominante={periodeDominante}
      rows={rows}
      isAdmin={isAdmin}
      onRefresh={fetchCompta}
    /> 
  );
};

export default ComptaItems;
